import { render } from "./RuggedSeparator.vue?vue&type=template&id=503a2628&scoped=true"
import script from "./RuggedSeparator.vue?vue&type=script&lang=js"
export * from "./RuggedSeparator.vue?vue&type=script&lang=js"

import "./RuggedSeparator.vue?vue&type=style&index=0&id=503a2628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503a2628"]])

export default __exports__